import { ResponseMapper } from "../../utils/httpclient/response/responsemapper";
import { Strings } from "../../utils/resources/strings";
import { SetStatusToneRequest } from "../api/statustune/setstatustune/setstatustonepricerequest";
import { SetStatusToneResponse, SetStatusToneResponseDtoImpl } from "../api/statustune/setstatustune/setstatustonepriceresponse";
import { BuyToneBuilder } from "../dto/buytone/buytonebuilder";
import { APIFeatures } from "../util/apifeatures";
import { StatusCodes } from "../util/statuscodes";
import { SixdeeCRBTAPIProcessor } from "./sixdeecrbtapiprocessor";

export class SetStatusToneAPIProcessorImpl extends SixdeeCRBTAPIProcessor<SetStatusToneRequest, SetStatusToneResponse>
{
    private packName:any;
    execute(request: SetStatusToneRequest): void 
    {
        this.packName = request.getSetStatusToneRequest().getPackName();
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new SetStatusToneResponseDtoImpl(APIFeatures.BUY_TONE, 
                    this.getContext().getResources().getString(Strings.your_order_is_successfully_completed));
                    
                  new BuyToneBuilder(this.packName, this.getContext()).buildAll();
                   
                this.getAPISuccess(response);
               
              
            }
        }
        catch (e) {
            
            console.log("----------failure");
            this.getAPIFailure(new SetStatusToneResponseDtoImpl(APIFeatures.BUY_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
  
        this.getAPIFailure(new SetStatusToneResponseDtoImpl(APIFeatures.BUY_TONE, responseMapper.getStatusMsg()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/setstatustonepriceapiprocessor.tsx